import { Select } from 'antd';
import React from 'react';
import { countries } from './countries';
import UrlHelper from 'common/utils/url-helper';

const CountriesSelect = (props) => {
  const {
    value = [],
    onChange,
    multiple = false,
    showPhoneCode,
    hideFlag = false,
    ...rest
  } = props;

  const handleChange = (value) => {
    if (value === undefined) {
      onChange?.([]);
    } else {
      onChange?.(value);
    }
  };

  /**
   * To turn off autocomplete
   */
  const handleOnFocus = (e) => {
    e.target.setAttribute('autocomplete', 'one-time-code');
  };

  return (
    <Select
      placeholder='Select Country'
      maxTagCount='responsive'
      onChange={handleChange}
      value={value}
      allowClear
      showSearch
      onFocus={handleOnFocus}
      autoComplete='off'
      optionFilterProp='label'
      {...rest}
    >
      {countries.map((opt, index) => {
        return (
          <Select.Option value={opt.code} label={opt.name} key={index}>
            <div className='flex gap-2 items-center justify-start pr-4'>
              {!hideFlag ? (
                <img
                  src={UrlHelper.getFlagIconUrl(opt.code)}
                  className='object-cover w-4'
                  alt={opt.name}
                />
              ) : null}
              <div className='flex-grow'>
                {opt.name}
                {showPhoneCode ? ` (${opt.phone_code})` : null}
              </div>
            </div>
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default CountriesSelect;
